// extracted by mini-css-extract-plugin
module.exports = {"our-projects":"our-projects_our-projects__Oc63e","title":"our-projects_title__334V0"};